import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Patient} from '../../_models';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-create-abeille-choice',
  templateUrl: './create-abeille-choice.component.html',
  styleUrls: ['./create-abeille-choice.component.scss']
})
export class CreateAbeilleChoiceComponent implements OnInit {

  @Output() choiceEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  choose(choice) {
        this.choiceEvent.emit(choice);
  }

}
